'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _et_EE = require('../locale/et_EE');

var _et_EE2 = _interopRequireDefault(_et_EE);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _et_EE2['default'];